export enum SubscriptionEventType {
  ORDER_CREATED = 'order.created',
  ORDER_UPDATED = 'order.updated',
}

export enum SubscriptionType {
  EMAIL = 'email',
  WEBHOOK = 'webhook',
}

export enum SubscriptionLoaderKey {
  GET_SUBSCRIPTION = 'get-subscription',
  CREATE_SUBSCRIPTION = 'create-subscription',
  TOGGLE_SUBSCRIPTION = 'toggle-subscription',
  UPDATE_SUBSCRIPTION = 'update-subscription',
  DELETE_SUBSCRIPTION = 'delete-subscription',

}
